import clsx from 'clsx';
import React, { useState } from 'react';

import FieldWrapper from '../FieldWrapper/FieldWrapper';

const TextAreaField = ({
  label,
  labelClassName,
  registration,
  required = false,
  defaultValue = null,
  isAiGenerated = false,
  ...otherProps
}) => {
  const { onChange, ...registrationRest } = registration;

  const [textareaheight, setTextareaheight] = useState(1);

  const handleChange = (event: React.ChangeEvent) => {
    const textareaLineHeight = 24;
    const minRows = 1;
    const maxRows = 10;
    const previousRows = (event.target as HTMLTextAreaElement).rows;
    (event.target as HTMLTextAreaElement).rows = minRows; // reset number of rows in textarea

    const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) {
      (event.target as HTMLTextAreaElement).rows = currentRows;
    }

    if (currentRows >= maxRows) {
      (event.target as HTMLTextAreaElement).rows = maxRows;
      event.target.scrollTop = event.target.scrollHeight;
    }

    const textareaheight = currentRows < maxRows ? currentRows : maxRows;

    setTextareaheight(textareaheight);
  };

  return (
    <FieldWrapper label={label} required={required} labelClassName={labelClassName}>
      <textarea
        className={clsx(
          'tw-min-h-[32px] tw-max-h-[200px] tw-w-full',
          'tw-border-solid tw-border-[1px] tw-border-cfo-grey-500',
          'tw-rounded-[3px]',
          'tw-px-[12px] tw-py-[4px]',

          'tw-text-cfo-black',
          'placeholder:tw-text-cfo-grey-600 focus-visible:tw-outline-0',
          isAiGenerated ? '!tw-bg-[rgba(240,232,250,1)]' : 'tw-bg-cfo-grey-100',
        )}
        {...otherProps}
        rows={textareaheight}
        defaultValue={defaultValue}
        onChange={(event) => {
          onChange(event);
          handleChange(event);
        }}
        {...registrationRest}
      />
    </FieldWrapper>
  );
};

export default TextAreaField;
